import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined'
import { CommonButton } from '@/components/common'

export const DonorsWhoGaveTable = ({
  donors = [],
  total = 0,
  loading,
  showingAll,
  onViewAll,
  onExport,
  loadingExport,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, md: 3 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mt: 3,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent='space-between'
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={1.5}
        sx={{ mb: 2 }}
      >
        <Stack spacing={0.5}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <GroupsOutlinedIcon sx={{ fontSize: 20 }} />
            <Typography variant='h6' fontWeight={700}>
              Donors Who Gave
            </Typography>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            A list of donors who successfully gave at this drive.
          </Typography>
        </Stack>
        <CommonButton
          variant='secondary'
          size='small'
          startIcon={<DownloadOutlinedIcon />}
          loading={loadingExport}
          onClick={onExport}
        >
          Download Excel
        </CommonButton>
      </Stack>

      <TableContainer sx={{ overflowX: 'auto' }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Donor Name</TableCell>
              <TableCell>Primary Email</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Blood Type</TableCell>
              <TableCell>Donation Type</TableCell>
              <TableCell align='center'>First Time Donor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell colSpan={6}>
                    <Skeleton variant='text' />
                  </TableCell>
                </TableRow>
              ))
            ) : donors.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align='center' sx={{ py: 3 }}>
                  <Typography variant='body2' color='text.secondary'>
                    No donors recorded for this drive.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              donors.map((donor, index) => (
                <TableRow key={`${donor.donor_name}-${index}`}>
                  <TableCell>{donor.donor_name}</TableCell>
                  <TableCell>{donor.primary_email || '—'}</TableCell>
                  <TableCell>{donor.primary_phone || '—'}</TableCell>
                  <TableCell>{donor.blood_type || 'Unknown'}</TableCell>
                  <TableCell>{donor.donation_type || '—'}</TableCell>
                  <TableCell align='center'>
                    {donor.is_first_time_donor ? 'Yes' : 'No'}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && !showingAll && total > donors.length && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <CommonButton variant='secondary' size='small' onClick={onViewAll}>
            View All Donors ({total})
          </CommonButton>
        </Box>
      )}
    </Paper>
  )
}

DonorsWhoGaveTable.propTypes = {
  donors: PropTypes.array,
  total: PropTypes.number,
  loading: PropTypes.bool,
  showingAll: PropTypes.bool,
  onViewAll: PropTypes.func,
  onExport: PropTypes.func,
  loadingExport: PropTypes.bool,
}
